import { render, staticRenderFns } from "./mNav.vue?vue&type=template&id=077b4986&"
import script from "./mNav.vue?vue&type=script&lang=js&"
export * from "./mNav.vue?vue&type=script&lang=js&"
import style0 from "./mNav.vue?vue&type=style&index=0&id=077b4986&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports